import { createContext } from 'react'
import { EditorContextType } from './types/editorContext'

export const EditorContext = createContext<EditorContextType>({} as EditorContextType)
